import home from './home.js';
import login from './login.js';
const notFound = [{
  path: "/404",
  name: '404',
  component: () => import("../../views/404.vue")
},
{
  path: '/:pathMatch(.*)*', // vue2可以使用 * ，vue3使用/:pathMatch(.*)*或/:pathMatch(.*)或/:catchAll(.*)
  redirect: {
    name: "404"
  }
}
]
const someThing = [
  {
    path: "/factory/screen",
    name: "factoryScreen",
    meta: {
      title: '大屏',
      scroll: true,
      permission: "waste:summary:dashboard:dataPlatform"
    },
    component: () => import("../../views/factory/screen.vue")
  },
  {
    path: "/factory/screen2",
    name: "factoryScreen2",
    meta: {
      title: '大屏',
      scroll: true,
      permission: "waste:summary:dashboard:operateMonitor"
    },
    component: () => import("../../views/factory/screen2.vue")
  },
  {
    path: "/factory/screen3",
    name: "factoryScreen3",
    meta: {
      title: '大屏',
      scroll: true,
      permission: "waste:summary:dashboard:dataPlatformNoMarket"
    },
    component: () => import("../../views/factory/screen3.vue")
  },
  {
    path: "/factory/screen4",
    name: "factoryScreen4",
    meta: {
      title: '大屏',
      scroll: true,
      permission: "waste:summary:dashboard:recycleDataPlatform"
    },
    component: () => import("../../views/factory/screen4.vue")
  },
  {
    path: "/hazardous/screen",
    name: "hazardousScreen",
    meta: {
      title: '大屏',
      scroll: true,
      permission: "hw:summary:dashboard:control"
    },
    component: () => import("../../views/hazardous/screen.vue")
  },
  {
    path: '/factory/writeOffList',
    name: "factoryWriteOffList",
    meta: {
      title: '核销列表',
      scroll: true,
      permission: ''
    },
    component: () => import("../../views/factory/writeOffList.vue"),
  },
]
export default [...login, ...home, ...notFound, ...someThing]
